import qs from 'qs'
import moment from 'moment'
import { isEmpty, isNil } from 'ramda'

const today = moment().unix()

export const defaultFilters = 'current_step:Complete AND tos:true AND case_status:Open'
export const defaultNumericFilters = [[`submission_deadline>=${today} | 0`]]

export const makeFilterString = ({ objectIds, prevFilters = defaultFilters }) => {
  if (isNil(objectIds)) return withoutObjectIds(prevFilters)

  const orObjectIds = objectIds
    .map(id => `objectID:${id}`)
    .join(' OR ')

  return `${prevFilters} AND (${orObjectIds})`
}

export const getFilterObjectIds = ({ ids = [], checked, prevFilters = defaultFilters }) => {
  if (isNil(checked)) return withoutObjectIds(prevFilters)

  const objectIds = ids.length ? ids : ['f9b08cb5afca4fff85809b5734f8da6b80cd'] // rand non existent id

  const orObjectIds = objectIds
    .map(id => `objectID:${id}`)
    .join(' OR ')

  return `${prevFilters} AND (${orObjectIds})`
}

const withoutObjectIds = filters => {
  const idx = filters.indexOf('objectID')
  const nextFilters = filters.slice(
    0,
    idx
  )
  return nextFilters.slice(0, nextFilters.lastIndexOf('AND'))
}

export const withObjectIds = filters => {
  const idx = filters.indexOf('objectID')
  return filters.slice(
    idx,
    filters.length - 1
  )
}

export const defaultState = {
  configure: {
    hitsPerPage: 12,
    paginationPadding: 1,
    filters: defaultFilters,
    numericFilters: defaultNumericFilters,
    typoTolerance: false
  },
  page: 1,
  clearAll: false
}

export const DEFAULT_RADIUS = 40225 // algolia places default search radius in meters

export const urlToSearchState = location => {
  const urlResult = qs.parse(location.search.slice(1))
  return isEmpty(urlResult) ? defaultState : urlResult
}
export const searchStateToUrl = (props, searchState) =>
  searchState ? `${props.location.pathname}${createURL(searchState)}` : ''
export const createURL = state => `?${qs.stringify(state)}`
